import { render, staticRenderFns } from "./DemoHeader.vue?vue&type=template&id=bcf000c8&scoped=true"
import script from "./DemoHeader.vue?vue&type=script&lang=js"
export * from "./DemoHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcf000c8",
  null
  
)

export default component.exports